import { render, staticRenderFns } from "./check_curriculum.vue?vue&type=template&id=873898c8"
import script from "./check_curriculum.vue?vue&type=script&lang=js"
export * from "./check_curriculum.vue?vue&type=script&lang=js"
import style0 from "./check_curriculum.vue?vue&type=style&index=0&id=873898c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports